<template>
  <div class="tw-bg-white tw-rounded-[12px] tw-p-8 tw-mt-8"
       v-for="(snd, index) in fields"
       :key="snd.key"
       :ref="el => itemRefs[index+1] = el">
    <div class="tw-flex tw-justify-between tw-items-center tw-mb-5">
      <h3 class="tw-text-base tw-text-static-headerGray">اسناد حسابداری
        ({{ index + 1 }})
      </h3>
      <button class="tw-bg-white tw-text-red-500" type="button" @click="remove_sanad(index)">
        <base-icon icon="trash" class="tw-align-middle" />
        حذف
      </button>
    </div>

    <div class="tw-block md:tw-grid md:tw-grid-cols-12 tw-gap-3 tw-mb-5">
      <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
        <select-users title="بستانکار"
                      placeholder="انتخاب بستانکار"
                      :additional-options="additional_options"
                      :errorMessage="errors['other_sanads['+index+'].bes_id']"
                      :disabled-options="[snd.value.bed_id]"
                      v-model="snd.value.bes_id" />
      </div>
      <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
        <select-users title="بدهکار"
                      placeholder="انتخاب بدهکار"
                      :errorMessage="errors['other_sanads['+index+'].bed_id']"
                      :additional-options="additional_options"
                      :disabled-options="[snd.value.bes_id]"
                      v-model="snd.value.bed_id" />
      </div>
      <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
        <input-ayandeh
          v-model:value="snd.value.amount"
          placeholder="وارد کردن مبلغ"
          :errorMessage="errors['other_sanads['+index+'].amount']"
          :number-format="true"
          float-label="مبلغ (ریال)" />
      </div>
    </div>
    <div class="tw-block md:tw-grid md:tw-grid-cols-12 tw-gap-3 tw-mb-5">
      <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
        <base-select title="نمایش به باربری"
                     placeholder="انتخاب نوع سند"
                     :disabled="snd.value.bes_id !== 'car'"
                     @change="() => { if (snd.value.type !== 'from_card_normal') snd.value.calc_amount_type = 'by_tonage'}"
                     :float-title="true"
                     :errorMessage="errors['other_sanads['+index+'].type']"
                     v-model="snd.value.type"
                     :options="sndTypeOpts" />
      </div>
      <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
        <base-select title="شیوه محاسبه مبلغ سند"
                     placeholder="انتخاب شیوه"
                     :disabled="snd.value.type && snd.value.type !== 'from_card_normal'"
                     :float-title="true"
                     :errorMessage="errors['other_sanads['+index+'].calc_amount_type']"
                     v-model="snd.value.calc_amount_type"
                     :options="calcAmountTypeOpts" />
      </div>
      <div class="tw-w-full md:tw-col-span-4 tw-mb-6 " :class="[
        !snd.value.bank_information && 'tw-flex tw-justify-between'
      ]">
        <div>
          <label :class="!snd.value.bank_information && 'tw-mb-0'">حساب بانکی واریز وجه</label>
          <p v-if="errors['other_sanads['+index+'].bank_information']"
             class="tw-text-red-300 tw-mb-0 tw-text-tiny"
             v-text="errors['other_sanads['+index+'].bank_information']"></p>
        </div>

        <div v-if="snd.value.bank_information">
          <div class="tw-flex tw-justify-between tw-mb-3">
            <div>
              <span class="tw-text-blue-dark-200">نام صاحب حساب</span>
              <base-icon icon="edit-note" size="20" class="tw-mr-4 tw-text-primary-500 tw-cursor-pointer tw-align-middle" @click="showModalStoreCreditCard(index)" />
            </div>
            <div class="tw-text-blue-dark-500 rtl"> {{ snd.value.bank_information.owner_name || 'بدون نام' }}</div>
          </div>
          <div class="tw-flex tw-justify-between tw-mb-3" v-if="snd.value.bank_information.credit_card">
            <span class="tw-text-blue-dark-200">شماره کارت</span>
            <div class="tw-text-blue-dark-500 ltr"> {{ snd.value.bank_information.credit_card.match(/.{1,4}/g).join(' ') }}</div>
          </div>
          <div class="tw-flex tw-justify-between tw-mb-3" v-if="snd.value.bank_information.shaba_num">
            <span class="tw-text-blue-dark-200">شماره شبا</span>
            <div class="tw-text-blue-dark-500 ltr"> {{ snd.value.bank_information.shaba_num }}</div>
          </div>
        </div>
        <new-btn v-else variant="outline" color="blue-dark" @click="showModalStoreCreditCard(index)">
          افزودن حساب بانکی
        </new-btn>
      </div>
      <add-new-credit-card v-model:visible="visible_modal_add_credit_card[index]"
                           @close="hideModalStoreCreditCard(index)"
                           :bank_information="snd.value.bank_information"
                           @updatedBank="(bank) => {snd.value.bank_information = bank;updateBankInfo(index)}"/>
    </div>
    <div class="tw-gap-3 tw-mb-5">
      <label>شرح سند حسابداری</label>
      <textarea cols="3"
                v-model="snd.value.description"
                :ref="el => descRefs[index] = el"
                placeholder="توضیحات"
                :class="[
                  errors['other_sanads['+index+'].description'] ? 'tw-border-red-200' : 'tw-border-static-inputBorder'
                ]"
                class="tw-border tw-w-full tw-rounded-[8px] tw-p-1.5 tw-min-h-[70px] placeholder:tw-text-gray-700"></textarea>
      <p v-if="errors['other_sanads['+index+'].description']"
         class="tw-text-red-300 tw-mb-0 tw-text-tiny"
         v-text="errors['other_sanads['+index+'].description']"></p>
    </div>
  </div>
</template>

<script setup>

import {ref, defineExpose, nextTick, watch, defineProps, defineEmits} from "vue";
import {apiGetSiteUsers} from "@/services/users/Users";
import SelectUsers from "@/components/base/select/SelectUsers.vue";
import BaseIcon from "@/components/base/BaseIcon.vue";
import BaseSelect from "@/components/base/select/BaseSelect.vue";
import InputAyandeh from "@/components/inputs/InputAyandeh.vue";
import NewBtn from "@/components/base/btn/NewBtn.vue";
import AddNewCreditCard from "@/components/bank_informations/AddNewCreditCard.vue";
import * as yup from 'yup'
import { useForm, useFieldArray } from 'vee-validate'


const loadingGetUsers = ref(null)
// const other_sanads = ref([])
const additional_options = [
  {
    label: 'کد حسابداری پلاک',
    value: 'car',
    user_id: 'car',
  },
  {
    label: 'باربری (صادر کننده بارنامه)',
    value: 'freightage',
    user_id: 'freightage',
  },
]
const sndTypeOpts = [
  { value: 'from_card_normal', label: 'عادی'},
  { value: 'from_card_reward', label: 'بابت کرایه'},
  { value: 'from_card_rent', label: 'بابت کرایه'},
]
const calcAmountTypeOpts = [
  { value: 'static', label: 'مبلغ ثابت'},
  { value: 'by_tonage', label: 'بر اساس تناژ'}
]
const visible_modal_add_credit_card = ref([])


// Form Validation
const sanadSchema = yup.object({
  bes_id: yup.string().required('بستانکار الزامی است'),
  bed_id: yup.string().required('بدهکار الزامی است'),
  type: yup.string().when('bes_id', {
    is: 'car',
    then: (schema) =>
      schema
        .typeError('نوع سند معتبر نیست')
        .required('نوع سند الزامی است'),
    otherwise: (schema) => schema.nullable(),
  }),
  amount: yup
    .number()
    .typeError('مبلغ معتبر نیست')
    .positive('مبلغ باید مثبت باشد')
    .required('مبلغ الزامی است'),
  calc_amount_type: yup.string().required('شیوه محاسبه مبلغ سند اجباری است'),
  bank_information: yup.object() .typeError('اصلاعات بانکی معتبر نیست').required('اصلاعات بانکی الزامی است'),
  description: yup.string().required('توضیحات الزامی است')
})

const { handleSubmit, errors, meta } = useForm({
  validationSchema: yup.object({
    other_sanads: yup.array().of(sanadSchema)
  })
})

const { fields, push, remove } = useFieldArray('other_sanads')

const props = defineProps({
  modelValue: {
    type: Array,
    default: []
  },
  validated: {
    type: Boolean,
    default: false,
  }
})

const emit = defineEmits(["update:modelValue", "update:validated"])

defineExpose({
  add_sanad
});

const itemRefs = ref({})
const descRefs = ref({})

function showModalStoreCreditCard(index) {
  visible_modal_add_credit_card.value[index] = true
}
function hideModalStoreCreditCard(index) {
  visible_modal_add_credit_card.value[index] = false
}
async function getUsers(search = '') {
  loadingGetUsers.value = true
  try {
    const response = await apiGetSiteUsers({
      search: search,
      type: 1,
      paginate: 10,
      page: pageUsers.value
    })

    if(!response) return
    if(pageUsers.value === 1) {
      users.value = response?.data?.users?.data
    } else {
      users.value = [...users.value, ...response?.data?.users?.data]
    }
    hasNextPageUsers.value = pageUsers.value < response?.data?.users?.last_page

  } catch (error) {
    console.log(error)
  } finally {
    loadingGetUsers.value = false
  }
}

function add_sanad() {
  const index = fields.value.length

  push({
    bed_id: null,
    bes_id: null,
    amount: '',
    calc_amount_type: 'static',
    description: '',
    type: 'from_card_normal',
    bank_information: null,
  })

  nextTick(() => {
    scrollToEl(index+1)
  })
}

async function updateBankInfo(item_num) {
  await nextTick()
  const el = descRefs.value[item_num]
  if(!el) return

  el.focus()
}
const scrollToEl = async (item_num) => {
  await nextTick()
  const el = itemRefs.value[item_num]
  if(!el) return

  el.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  })
}

function remove_sanad(index) {
  console.log('remove')
  remove(index)
  // other_sanads.value.splice(index, 1)
}

watch(
  fields,
  (val) => emit('update:modelValue', val.map(x => x.value)),
  { deep: true }
)

watch(
  () => meta.value.valid,
  (isValid) => {
    emit('update:validated', isValid)
  }
)

</script>
